document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.mobilesearch').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();

      let lis = document.querySelectorAll('#sidebar .nav li');
      let search = document.querySelector('#sidebar .nav li.search');

      if (el.classList.contains('cancel')) {
        el.classList.remove('cancel');
        lis.forEach(function(li) {
          li.style.display = 'inline-block';
        });
        search.style.display = 'none';
      } else {
        el.classList.add('cancel');
        lis.forEach(function(li) {
          li.style.display = 'none';
        });
        search.style.display = 'block';
      }
    });
  });

});
